import { render, staticRenderFns } from "./OcrIdentity.vue?vue&type=template&id=adcf2df6&"
import script from "./OcrIdentity.vue?vue&type=script&lang=ts&"
export * from "./OcrIdentity.vue?vue&type=script&lang=ts&"
import style0 from "./OcrIdentity.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports